import { useMemo } from 'react';
import {
  useGetUserProfile,
  type UserProfileOptions,
} from '@leagueplatform/web-common';
import {
  normalizeCustomFields,
  normalizePhoneNumbers,
} from 'common/utils/normalize-custom-fields.util';
import type { ScanData } from './types';

export const useGetScanUserProfile = (
  options?: UserProfileOptions,
  userId?: string,
) => {
  const { data, ...restUseQueryReturns } = useGetUserProfile(options, userId);

  const scanData = data as ScanData;

  const normalizedData = useMemo(() => {
    if (scanData) {
      const normalizedCustomFields = normalizeCustomFields(
        scanData?.customFields,
      );
      const normalizedPhoneNumbers = normalizePhoneNumbers(
        scanData?.phoneNumbers,
      );

      return {
        ...scanData,
        customFields: normalizedCustomFields,
        phoneNumbers: normalizedPhoneNumbers,
      };
    }
    return scanData;
  }, [scanData]);

  return {
    data: normalizedData,
    ...restUseQueryReturns,
  };
};
